module.exports = __webpack_public_path__ + "img/btn_vrtour.e80e9812.png";